import { Box, Flex, HStack, VStack } from '@chakra-ui/react'
import { Field, FieldArray, Formik } from 'formik'
import { Fragment, useState } from 'react'
import { Button, InputForm, SelectForm, TextAreaForm } from 'uikit'
import { Form } from 'uikit/layout'
import * as Yup from 'yup'
import { faqCategoryOptions, faqTextOptions } from '../Faq.constants'

const formSchema = Yup.object({
  // subject: Yup.string().required('Поле обязательно'),
})

export const ItemForm = ({ onSubmit, onRemove, initialValues, isLoading }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <Formik
      enableReinitialize
      initialValues={{ list: [], ...initialValues }}
      onSubmit={onSubmit}
      validationSchema={formSchema}
      validateOnMount
    >
      {(props) => {
        return (
          <Form>
            <VStack gap="20px" alignItems="flex-start">
              <Flex>
                <FieldArray
                  name="list"
                  render={() => (
                    <>
                      {faqTextOptions.map((option, index) => (
                        <Fragment key={index}>
                          <Button
                            size="sm"
                            key={index}
                            colorPalette={activeIndex === index ? 'orange' : 'gray'}
                            onClick={() => setActiveIndex(index)}
                            mr={2}
                          >
                            {option.label}
                          </Button>
                        </Fragment>
                      ))}
                    </>
                  )}
                />
              </Flex>

              <Field
                name={`list[${activeIndex}].question`}
                label="Вопрос"
                component={TextAreaForm}
                minHeight="200px"
                disabled={isLoading}
              />
              <Field
                name={`list[${activeIndex}].answer`}
                label="Ответ"
                component={TextAreaForm}
                minHeight="200px"
                disabled={isLoading}
              />
              <Field
                name="category"
                label="Категория"
                component={SelectForm}
                disabled={isLoading}
                options={faqCategoryOptions}
                placeholder="Выберите категорию"
              />
              <Field
                name="order"
                label="Порядковый номер"
                component={InputForm}
                disabled={isLoading}
              />
            </VStack>

            <Box pt="30px">
              <HStack gap={4} justifyContent="space-between">
                <Button
                  onClick={() => props.handleSubmit()}
                  colorPalette="orange"
                  loading={isLoading}
                  disabled={!props.isValid}
                  minW="120px"
                >
                  {initialValues ? 'Обновить' : 'Добавить'}
                </Button>
                {initialValues && (
                  <Button
                    onClick={onRemove}
                    colorPalette="red"
                    loading={isLoading}
                    disabled={!props.isValid}
                    minW="120px"
                  >
                    Удалить
                  </Button>
                )}
              </HStack>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}
